import React from "react"
import PropTypes from "prop-types"
import { Modal, Space } from "antd"

import { Markdown, MarkdownAlert } from "@components/Text"

const LABEL_YES = "Yes, I have sent the funds"
const LABEL_TITLE = "Confirm Fund Transfer"
const LABEL_CONFIRM_ALERT = `Please note, clicking this button does not initiate a
bank debit or wire transfer.`
const LABEL_CONFIRM = `You must complete the wire transfer manually through
your bank using the instructions provided.

Only click "**Yes, I have sent the funds**" after you have completed the
transfer.

Once confirmed, your funding status will be updated to **Processing**. You will
be notified when the funds are received.`


const InvestmentFundedInvestorModal = ({
  onOk,
  isOpen,
  onCancel,
  isLoading,
}) => {
  const modalProps = {
    open: isOpen,
    title: LABEL_TITLE,
    okText: LABEL_YES,
    confirmLoading: isLoading,
    onOk,
    onCancel,
  }

  return (
    <Modal {...modalProps}>
      <Space direction="vertical" size={0}>
        <MarkdownAlert
          text={LABEL_CONFIRM_ALERT}
          type="warning"
          style={{ marginBottom: 0 }}
        />

        <Markdown
          text={LABEL_CONFIRM}
        />
      </Space>
    </Modal>
  )
}

InvestmentFundedInvestorModal.propTypes = {
  onOk: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
}

export default InvestmentFundedInvestorModal
